import React, { FC } from 'react';
import IntegrationSubscription from '../IntegrationSubscription/IntegrationSubscription';

const FastAccessPanel: FC = () => {
  return (
    <div style={{ width: '90%' }}>
      <IntegrationSubscription />
    </div>
  );
};

export default FastAccessPanel;
